export class Observacio {    
    descripcio: string;
    id: number;
    idConjunt: number;
}